import { iProfile } from '@/entities/profile/profile.types';
import { iProfileService } from './profile.types';
import { iFirestoreProfileModel } from '../firestore/firestore.types';

export default class ProfileService implements iProfileService {
  db: iFirestoreProfileModel;

  constructor(db: iFirestoreProfileModel) {
    this.db = db;
  }

  findByIdOrSlug(idOrSlug: string): Promise<iProfile> {
    return this.db.findByUserIdOrSlug(idOrSlug);
  }
}
